import React from 'react';
import moment from "moment";
import { isValidCNPJ, isValidCPF } from './valid';

//Objeto de campo padronizado para envio a função validarCampos
export const objCampo = ({ name, required, number, email, cnpj, cpf, cpfcnpj, date, birthDate, placa }) => {
    return { name, required, number, email, cnpj, cpf, cpfcnpj, date, birthDate, placa };
}
export const validarCampos = (obj, campos) => {
    const objetoDeErros = {}

    //Regex para validação de email
    const emailRegex = /\S+@\S+/;

    //Regex para validação de placa de carro
    const placaRegex = /^[A-Za-z]{3}[0-9][0-9A-Za-z][0-9]{2}$/;

    const erros = campos.filter(campo => {

        //Validação de campo obrigatorio
        if (!obj[campo.name] || campo.required && (obj[campo.name] === "" || obj[campo.name].length === 0 || Object.keys(obj[campo.name]).length === 0)) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "";
            return campo;
        }

        //Validação de campo numerico
        if (campo.number && isNaN(obj[campo.name].replace(',', '.'))) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "* O valor não é numérico";
            return campo;
        } else if (campo.number && parseFloat(obj[campo.name].replace(',', '.')) === 0.00) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "";
            return campo;
        }

        //Validação de campo de email
        if (campo.email && !emailRegex.test(obj[campo.name])) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "* E-mail inválido";
            return campo;
        }

        //Validação de campo de placa de carro
        if (campo.placa) {
            const num = obj[campo.name].replace(/[^0-9a-zA-Z]/g, '');
            if (!placaRegex.test(num)) {
                objetoDeErros[campo.name] = {};
                objetoDeErros[campo.name].message = "* Placa inválida";
                return campo;
            }
        }

        //Validação de campo de cnpj
        if (campo.cnpj && !isValidCNPJ(obj[campo.name])) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "* CNPJ inválido";
            return campo;
        }

        //Validação de campo de cpf
        if (campo.cpf && !isValidCPF(obj[campo.name])) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "* CPF inválido";
            return campo;
        }

        //Validação de campo que possui a opção de ser cpf ou cnpj
        if (campo.cpfcnpj) {
            if (obj[campo.name].length <= 11 && !isValidCPF(obj[campo.name])) {
                objetoDeErros[campo.name] = {};
                objetoDeErros[campo.name].message = "* CPF inválido";
                return campo;
            } else if (obj[campo.name].length > 11 && obj[campo.name].length <= 14 && !isValidCNPJ(obj[campo.name])) {
                objetoDeErros[campo.name] = {};
                objetoDeErros[campo.name].message = "* CNPJ inválido";
                return campo;
            }

        }

        //Validação de campo de data
        if (campo.date && !isValidDate(obj[campo.name])) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "* Data inválida";
            return campo;
        }

        //Validação de campo de aniversario
        if (campo.birthDate && !isValidDataNascimento(obj[campo.name])) {
            objetoDeErros[campo.name] = {};
            objetoDeErros[campo.name].message = "* Data inválida";
            return campo;
        }
    })

    return [objetoDeErros, erros];
}

// Função para mostrar o resultado do erro para determinado campo
export const PrintValidate = ({ errors, field }) => {
    return (
        <span className="mb-4">
            {errors[field] && <span className={"form-control-label text-danger"}>{errors[field].message}</span>}
        </span>
    )
}


//Função de validação de data
function isValidDate(input_date) {
    if (!moment(input_date, "YYYY-MM-DD", true).isValid())
        return false;
    else {
        var minDate = moment.utc("1900-01-01");
        if (moment(input_date, "YYYY-MM-DD", true).isAfter(minDate))
            return true;
        else
            return false;
    }
}

//Função de validação de data de nascimento
function isValidDataNascimento(input_date) {
    if (!isValidDate(input_date))
        return false;
    else {
        var current_date = moment(new Date()).format("YYYY-MM-DD");
        var date = moment(input_date, "YYYY-MM-DD", true);

        if (date.diff(current_date, 'days') > 0)
            return false;
        else
            return true;
    }
}